import React, { forwardRef } from 'react';
import classnames from 'classnames';
import styles from './RadioButton.module.scss';
import { RadioButtonProps } from './types';

const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(
  (
    {
      id,
      name,
      onChange,
      label,
      labelText,
      checked,
      dataTestId,
      value,
      theme = 'unselected-circle',
      disabled,
    },
    ref?,
  ) => (
    <div className={styles['form-group']}>
      <input
        id={id}
        name={name}
        type="radio"
        disabled={disabled}
        onChange={() => {
          onChange(value);
        }}
        checked={checked}
        aria-checked={checked}
        data-testid={dataTestId ?? 'radio-input'}
        ref={ref}
      />
      <label htmlFor={id} data-testid="checkbox-label">
        <div
          className={classnames(
            styles['check-mark'],
            styles[theme],
            disabled && styles['check-mark-disabled'],
          )}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              if (document && id) {
                // Simulate a click on the input when Enter is pressed
                document?.getElementById(id)?.click();
              }
            }
          }}
          aria-label={labelText || (typeof label === 'string' ? label : '')}
          role="radio"
          aria-checked={checked}
          tabIndex={0}
        />
        <div className={styles.label}>{label}</div>
      </label>
    </div>
  ),
);

export default RadioButton;
